<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.48559 11.2039H20.42C20.8574 11.2039 21.2127 11.5582 21.2127 11.9956C21.2127 12.4329 20.8574 12.7882 20.42 12.7882H5.48559L11.5236 18.8263C11.8329 19.1355 11.8329 19.6379 11.5236 19.9472C11.2144 20.2564 10.7129 20.2564 10.4037 19.9472L3.01251 12.556C2.91743 12.461 2.85139 12.3479 2.81436 12.2278V12.2268V12.2258V12.2248C2.79434 12.1587 2.78233 12.0876 2.78033 12.0156V12.0146V12.0116V12.0106V12.0086V12.0066V12.0056V12.0036V12.0006V11.9956C2.78033 11.9946 2.78033 11.9926 2.78033 11.9906V11.9886V11.9866V11.9856V11.9826V11.9816V11.9806V11.9776V11.9766C2.78233 11.9045 2.79434 11.8334 2.81436 11.7674V11.7654V11.7644C2.85139 11.6443 2.91743 11.5312 3.01251 11.4361L10.4037 4.04495C10.7129 3.73569 11.2144 3.73569 11.5236 4.04495C11.8329 4.3542 11.8329 4.85562 11.5236 5.16487L5.48559 11.2039Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowBack'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
